import { useMemo } from 'react';

import styled from '@emotion/styled';
import { Grid, Link } from '@kc-console/common-ui';
import { getUserGuidePath } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';

import MegaMenuGlobalSidebarDesc from './MegaMenuGlobalSidebarDesc';
import MegaMenuGlobalSidebarMenuItem from './MegaMenuGlobalSidebarMenuItem';

const GlobalSidebar = () => {
  const { t } = useTranslation();
  const infoLinks = useMemo(
    () => [
      {
        label: t('layout:mega_menu.header.project_role_guide'),
        href: getUserGuidePath('service/management/iam/roles/project-roles'),
      },
      {
        label: t('layout:mega_menu.header.project_create_guide'),
        href: getUserGuidePath('service/management/iam/how-to-guides/iam-manage-project'),
      },
    ],
    [t],
  );
  return (
    <GlobalSidebarWrapper display={'flex'} gap={'8px'} flexDirection={'column'}>
      <MegaMenuGlobalSidebarDesc />
      <Grid display={'flex'} gap={'8px'} flexWrap={'wrap'}>
        {infoLinks.map(link => (
          <Link key={link.label} href={link.href} size="md" external>
            {link.label}
          </Link>
        ))}
      </Grid>
      <MegaMenuGlobalSidebarMenuItem />
    </GlobalSidebarWrapper>
  );
};

export default GlobalSidebar;

const GlobalSidebarWrapper = styled(Grid)`
  width: 100%;
`;
